import { faFile, faFileContract, faFileUser, faMemo } from '@fortawesome/pro-solid-svg-icons'

import { InternshipFileTypes } from '../../../utils/entities/internshipRequestFile'
import FilesUploader from '../../../Components/antd/Uploaders/FilesUploader'
import FormItem from '../../../Components/shared/Forms/FormItem'

const { RESUME, COVER_LETTER, CONVENTION, OTHER } = InternshipFileTypes

export const DEFAULT_DATA = { [RESUME]: [], [COVER_LETTER]: [], [CONVENTION]: [], [OTHER]: [] }

const InternshipRequestFilesForm = ({ errorFields, files = DEFAULT_DATA, requiredFields = {}, setFiles }) => {
  const handleUpload = key => file => {
    setFiles({ ...files, [key]: [...files[key], file] })
  }
  const handleRemove = key => file => {
    setFiles({ ...files, [key]: files[key].filter(f => f.uid !== file.uid) })
  }

  const getClassName = field => (errorFields.includes(field) ? 'error-ant-border' : '')

  return (
    <>
      <FormItem icon={faFileUser} label='form.label.cv' required={requiredFields.RESUME}>
        <FilesUploader
          className={getClassName(RESUME)}
          files={files[RESUME]}
          onUpload={handleUpload(RESUME)}
          onRemove={handleRemove(RESUME)}
        />
      </FormItem>
      <FormItem icon={faMemo} label='form.label.motivation_letter' required={requiredFields.COVER_LETTER}>
        <FilesUploader
          className={getClassName(COVER_LETTER)}
          files={files[COVER_LETTER]}
          onUpload={handleUpload(COVER_LETTER)}
          onRemove={handleRemove(COVER_LETTER)}
        />
      </FormItem>
      <FormItem icon={faFileContract} label='form.label.convention' required={requiredFields.CONVENTION}>
        <FilesUploader
          className={getClassName(CONVENTION)}
          files={files[CONVENTION]}
          onUpload={handleUpload(CONVENTION)}
          onRemove={handleRemove(CONVENTION)}
        />
      </FormItem>
      <FormItem icon={faFile} label='form.label.other_files'>
        <FilesUploader
          files={files[OTHER]}
          onUpload={handleUpload(OTHER)}
          onRemove={handleRemove(OTHER)}
        />
      </FormItem>
    </>
  )
}

export default InternshipRequestFilesForm
